// @ts-ignore
import { useUserContext } from "../../Contexts/UserProvider.tsx";
import { config } from "./config";
// @ts-ignore
import useApi from "./ServiceClient";

export const useTenantManagement = () => {
  const { GET, POST, DELETE } = useApi(); // Use API methods inside a React hook

  const getTenantDetail = () => {
    const response = GET(
      config?.tenant_management?.END_POINTS?.GET_TENANT_DETAIL
    );
    return response;
  };

  const createTenant = (data) => {
    const response = POST(
      config?.tenant_management?.END_POINTS?.TENANT_CREATE,
      data
    );
    return response;
  };

  const updateTenant = (data) => {
    const response = POST(
      config?.tenant_management?.END_POINTS?.TENANT_UPDATE,
      data
    );
    return response;
  };

  const deleteTenant = (tenantId) => {
    const response = DELETE(
      `${config?.tenant_management?.END_POINTS?.TENANT_DELETE}/${tenantId}`
    );
    return response;
  };

  const getTenantsForUsers = () => {
    const response = GET(
      `${config?.tenant_management?.END_POINTS?.TENANTS_FOR_USER}`
    );
    return response;
  }

  return {
    getTenantDetail,
    createTenant,
    updateTenant,
    deleteTenant,
    getTenantsForUsers
  };
};
